import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  LabelList,
} from "recharts";

const CustomLabel = (props) => {
  const { x, y, width, value, index, data } = props;
  if (!data || !data[index]) return null;
  return (
    <g>
      <text
        x={x + width + 10}
        y={y + 5}
        fill="#6b6b6b"
        fontSize={12}
        fontWeight="500"
        alignmentBaseline="middle"
      >
        {data[index].name}
      </text>

      <text
        x={x + width + 10}
        y={y + 15}
        fill="#ffa32e"
        fontSize={10}
        fontWeight="500"
        alignmentBaseline="middle"
      >
        {data[index].displayValue}
      </text>
    </g>
  );
};
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #ffa32e",
          borderRadius: 6,
          padding: "8px 12px",
          color: "#333",
          fontSize: 13,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ fontWeight: "bold", marginBottom: 4 }}>{data.name}</div>
        <div>
          <span style={{ color: "#333", fontWeight: 600 }}>
            Open Sales : {data.openSales}
          </span>
        </div>
        <div>
          <span style={{ color: "#333", fontWeight: 600 }}>
            Closed Sales : {data.closedSales}
          </span>
        </div>
        <div>
          <span style={{ color: "#333", fontWeight: 600 }}>
            Target : {data.targetValue}
          </span>
        </div>
        <div>
          <span style={{ color: "#333", fontWeight: 600 }}>
            Total : {data.displayValue}
          </span>
        </div>
      </div>
    );
  }
  return null;
};

const WebBarChart = ({ chartData }) => {
  const minHeight = chartData.length === 1 ? 150 : 300;
  const sortedChartData = [...chartData].sort((a, b) => b.value - a.value);
  const chartHeight = Math.max(chartData.length * 60, minHeight);

  // Find max value for domain
  const maxValue =
    sortedChartData.length > 0
      ? Math.max(...sortedChartData.map((d) => d.value))
      : 0;

  // Calculate dynamic width for YAxis based on longest name
  const getYAxisWidth = () => {
    const avgCharWidth = 7.5; // Average character width in pixels at 12px font
    const maxNameLength = Math.max(
      ...sortedChartData.map((d) => (d.name || "").length)
    );
    const calculatedWidth = Math.ceil(maxNameLength * avgCharWidth) + 20; // Add padding
    return Math.max(calculatedWidth, 120); // Ensure minimum width of 120px
  };

  return (
    <div
      style={{
        height: chartHeight,
        overflowY: "auto",
        width: "100%",
      }}
    >
      <ResponsiveContainer width="100%" height={chartHeight}>
        <BarChart
          layout="vertical"
          data={sortedChartData}
          spacing={5}
          spaceBetweenTicks={5}
          margin={{ top: 10, right: 60, left: 40, bottom: 10 }}
          barCategoryGap={5}
          barGap={0}
        >
          <XAxis
            type="number"
            domain={
              sortedChartData.length === 1
                ? [0, Math.max(maxValue * 1.2, 10)] // Ensure domain is wide enough
                : ["auto", "auto"]
            }
            tickFormatter={(value) => value.toFixed(0)}
            // hide
          />
          <YAxis
            type="category"
            dataKey="name"
            width={getYAxisWidth()}
            tick={{ fontSize: 12, fontWeight: 500 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="value"
            isAnimationActive
            fill="#d17813ff"
            barSize={sortedChartData.length === 1 ? 40 : 30} // Ensure visible bar for single data
          >
            {sortedChartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color || "#d17813ff"} />
            ))}
            <LabelList
              dataKey="value"
              content={(props) => (
                <CustomLabel {...props} data={sortedChartData} />
              )}
            />
          </Bar>
          {/* <Bar
            dataKey="target"
            fill="#b7b6b6ff"
            name="Planned Sales"
            barSize={8}
          >
            <LabelList
              dataKey="target"
              content={(props) => (
                <g>
                  <text
                    x={props.x + props.width + 10}
                    y={props.y + 5}
                    fill="#6b6b6b"
                    fontSize={10}
                    fontWeight="500"
                    alignmentBaseline="middle"
                  >
                    {"Target : "}
                  </text>
                  <text
                    x={props.x + props.width + 10}
                    y={props.y + 20}
                    fill="#ffa32e"
                    fontSize={10}
                    fontWeight="500"
                    alignmentBaseline="middle"
                  >
                    {sortedChartData[props.index].targetValue}
                  </text>
                </g>
              )}
            />
          </Bar> */}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WebBarChart;
